export default __webpack_public_path__ + "static/media/Illustrace 2.889fdc3e.png";